<!--
 * @Author: your name
 * @Date: 2021-05-27 17:09:02
 * @LastEditTime: 2021-06-03 14:46:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\htistory.vue
-->
<template>
  <div class="">
    <div v-for="item in applyList" :key="item.id" class="weui-flex " style="width:90%;padding: 15px;">
      <div style="width:100%;background-color:white; border-radius: 15px;">
        <div class="weui-flex recordContainer">
          <div class="recordLeft">
            <div class="weui-flex recordItem">
              <div class="weui-flex recordItemTitle">
                被访人：
              </div>
              <div class="weui-flex recordItemContent" style="color: black;">
                {{item.visitedname}}
              </div>
            </div>
            <div class="weui-flex recordItem">
              <div class="weui-flex recordItemTitle">
                申请时间：
              </div>
              <div class="weui-flex recordItemContent" style="color: black;">
                {{item.submitdate}}
              </div>
            </div>
            <div class="weui-flex recordItem" v-if="item.visitorstate<2?true:false">
              <div class="weui-flex recordItemTitle">
                入园时间：
              </div>
              <div class="weui-flex recordItemContent" style="color: black;">
                {{item.estimateintoparktime}}(预计)
              </div>
            </div>
            <div class="weui-flex recordItem" v-if="item.visitorstate<2?false:true">
              <div class="weui-flex recordItemTitle">
                入园时间：
              </div>
              <div class="weui-flex recordItemContent" style="color: black;">
                {{item.firstintopark}}
              </div>
            </div>
            <div class="weui-flex recordItem" v-if="item.visitorstate<2?true:false">
              <div class="weui-flex recordItemTitle">
                离园时间：
              </div>
              <div class="weui-flex recordItemContent" style="color: black;">
                {{item.estimateleavetime}}(预计)
              </div>
            </div>
            <div class="weui-flex recordItem" v-if="item.visitorstate>= 2?true:false">
              <div class="weui-flex recordItemTitle">
                离园时间：
              </div>
              <div class="weui-flex recordItemContent" style="color: black;">
                {{item.actualleavetime}}
              </div>
            </div>
            <div class="weui-flex recordItem">
              <div class="weui-flex recordItemTitle">
                来访事由：
              </div>
              <div class="weui-flex recordItemContent" style="color: black;">
                {{item.visitreason}}
              </div>
            </div>
            <div class="weui-flex recordItem" v-if="item.carnumber== null?false:true">
              <div class="weui-flex recordItemTitle">
                车牌号：
              </div>
              <div class="weui-flex recordItemContent" style="color: black;">
                {{item.carnumber}}
              </div>
            </div>
          </div>
          <!-- 待批准入园 -->
          <div v-if="item.visitorstate===0" class="recordRight">
          </div>
          <!-- 待入园 -->
          <div v-if="item.visitorstate===1" class="recordRight1">
          </div>
          <!-- 接待中 -->
          <div v-if="item.visitorstate===2" class="recordRight2">
          </div>
          <!-- 结束 -->
          <div v-if="item.visitorstate===3" class="recordRight3">
          </div>
          <!-- 未通过 -->
          <div v-if="item.visitorstate===4" class="recordRight4">
          </div>
        </div>
        <div class="weui-flex" style="padding-left:10px;padding-right:10px">
          <div class="weui-flex__item line"></div>
        </div>
        <div class="weui-flex" style="justify-content: flex-end;padding-right: 10px ">
          <div class=" buttonContainer" v-if="item.visitorstate ===0 || item.visitorstate===1">
            <a href="#" @click="cancelVisit(item)" class="weui-btn vtpButton" style="width:80px">取消来访</a>
          </div>
          <div class=" buttonContainer" v-if="showTwice">
            <a href="#" class="weui-btn vtpButton" style="width:80px" @click="applymore(item.id)">再次申请</a>
          </div>
          <div class="  buttonContainer" v-if="showHistory && item.carnumber== null?true:false">
            <a href="#" class="weui-btn vtpButton" @click="signRecord(item)" style="width:100px">签入/出记录</a>
          </div>
        </div>
      </div>
    </div>
    <div class="weui-mask" v-if="siginRecordsMask" @click="colseDialog"></div>
    <div class="weui-dialog" v-if="siginRecordsMask">
      <div class="weui-dialog__hd"><strong class="weui-dialog__title">签入/出记录</strong></div>
      <div class="weui-dialog__bd">
        <ul>
          <div style="display:flex;">
            <div class="currentState">当前状态</div>
            <div class="centerContainer">
              <div class="verticalLineFirst">
              </div>
              <img id="u213_img" class="firstLineBigCircel">
              <img id="u214_img" class="firstLineSmallCircel">
            </div>
            <div class="rightContainer">{{siginRecordsState}}</div>
          </div>
          <div v-for="item in siginRecordList " :key=item.id style="display:flex;flex-wrap: wrap;flex-direction:column;">
            <div style="display:flex;width: 100%;">
              <div class="currentState">{{item.date}}</div>
              <div class="centerContainer">
                <div class="verticalLine">
                </div>
                <div style="display:flex;width:20px; "></div>
                <img id="u213_img" class="lineSmallCircel">
              </div>
              <div class="rightContainer"></div>
            </div>
            <div v-for="i in item.dataList " :key="i.id" style="display:flex;width: 100%;">
              <div class="currentState">{{i.operatetime|operateTime}}</div>
              <div class="centerContainer">
                <div class="verticalLine">
                </div>
                <div style="display:flex;width:20px; "></div>
                <img id="u213_img" class="lineSmallCircel">
              </div>
              <div class="rightContainer">{{i.visitorname}} &nbsp;&nbsp;&nbsp;&nbsp; 签{{i.type}}</div>
            </div>
          </div>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '../request/http'
import store from '@/store/index'
import { Toast } from 'we-vue'
export default {
  components: {},
  data() {
    return {
      showTwice: true,
      showHistory: true,
      applyList: [],
      siginRecordsMask: false,
      siginRecordList: [],
      stateUrl: '',
      siginRecordsState: ''
    }
  },
  computed: {},
  methods: {
    timeshow() {

    },
    applymore(value) {
      this.$router.push({
        name: 'edit',
        params: {
          itemid: value
        }
      })
    },
    colseDialog() {
      this.siginRecordsMask = false
    },
    // 取消来访
    cancelVisit(item) {
      this.$weui.dialog({
        title: '警告',
        content: '<i class="weui-icon-warn"></i>您确认取消此申请吗？',
        className: 'custom-classname',
        buttons: [{
          label: '取消',
          type: 'default',
          onClick: () => {
            return
          }
        }, {
          label: '确定',
          type: 'primary',
          onClick: () => {
            var loading = this.$weui.loading('处理中，请稍侯。')
            postAction("/vtp/toaEnterParkApply/cancelvisit", { item }).then((res) => {
              loading.hide()
              if (res.data.success) {
                Toast.success('取消来访成功')
                this.$forceUpdate()
              } else {
              //  Toast.fail('取消来访失败')
                if (res.data.message) {
                  Toast.fail(res.data.message)
                } else {
                  Toast.fail('取消来访失败')
                }
              }
              this.getAllApplyRecords()
            }).catch((err) => {
              loading.hide()
            })
          }
        }]
      })
    },
    // 查询签入/出记录
    signRecord(item) {
      this.siginRecordsState = item.dispvisitorstate
      getAction("vtp/toaEnterParkSignRecords/getSignRecordsByApplyDoc", { id: item.id, estimateintoparktime: item.estimateintoparktime, estimateleavetime: item.estimateleavetime }).then((res) => {
        if (res.data.success) {
          this.siginRecordList = res.data.result.reverse()
          this.siginRecordsMask = true
        }
      })
    },
    getAllApplyRecords() {
      // 获取openid
      // var openid = store.state.openid
      var openid = ''
      // 获取入园申请记录
      if (this.$route.query.cancleable !== '' && this.$route.query.cancleable !== undefined) {
        // 点击取消来访
        getAction('/vtp/toaEnterParkApply/list', { qry_visitorstate: '0,1' }).then((res) => {
          this.applyList = res.data.result.dataList
          this.showTwice = false
          this.showHistory = false
          if (this.applyList.length === 0) {
            Toast.fail('未查询到您的申请记录！')
          }
        })
      } else {
        getAction("/vtp/toaEnterParkApply/list", { }).then((res) => {
          this.applyList = res.data.result.dataList
          if (this.applyList.length === 0) {
            Toast.fail('未查询到您的申请记录！')
          }
        })
      }
    }
  },
  created() {
    // 获取openid
    this.getAllApplyRecords()
    // this.$router.go(0)
  },
  mounted() {
    this.timeshow()
  },
  beforeCreate() {
    document.title = "申请记录"
  },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() {
  },
  filters: {
    operateTime(value) {
      // 兼容ios
      let reg = new RegExp('-', 'g') // g代表全部
      value = value.replace(reg, '/')
      var dateTime = new Date(value)
      // 获取时、分
      var hours = dateTime.getHours()
      var minutes = dateTime.getMinutes()
      return hours + ':' + minutes
    }
  }
}
</script>
<style  scoped>
.warn {
  color: red;
  width: 100px;
}
.noRecords {
  text-align: center;
}
.verticalLineFirst {
  display: flex;
  width: 1px;
  border-left: 1px solid rgb(227, 234, 241);
  height: 18px;
  align-self: flex-end;
  position: relative;
  left: 25%;
}
.rightContainer {
  display: flex;
  flex: 6;
  flex-direction: row;
  width: 1px;
  margin-left: 10px;
  width: 60%;
}
.firstLineSmallCircel {
  position: relative;
  left: -16px;
  content: url(../assets/u214.svg);
}
.lineSmallCircel {
  position: relative;
  left: -16px;
  content: url(../assets/u207.svg);
}
.firstLineBigCircel {
  width: 20px;
  height: 20px;
  content: url(../assets/u213.svg);
}
.centerContainer {
  display: flex;
  flex-direction: row;
  flex: 2;
  height: 26px;
  align-items: center;
  justify-content: center;
}
.currentState {
  display: flex;
  flex-direction: row;
  flex: 3;
}
.verticalLine {
  display: flex;
  width: 1px;
  border-left: 1px solid rgb(227, 234, 241);
  height: 40px;
  position: relative;
  left: 25%;
}
.line {
  margin-top: 5px;
  background-color: #ececec;
  height: 1px;
}
.vtpButton {
  margin-top: 7px;
  padding: 8px 8px;
  color: rgb(22, 145, 213);
  border: 1px solid;
  line-height: 0.5;
  width: 90px;
  margin-right: 15px;
  font-size: 14px;
  font-weight: 400;
}
.recordContainer {
  width: 100%;
}
.recordLeft {
  padding-top: 10px;
  width: 80%;
}
.recordItem {
  width: 100%;
  height: 30px;
  line-height: 30px;
}
.recordItemTitle {
  font-family: '苹方 常规', '苹方 中等', '苹方', sans-serif;
  color: #666666;
  text-indent: 10px;
  font-size: 17px;
  font-weight: 400;
  line-height: 30px;
  flex: 2;
}
.recordItemContent {
  font-weight: 100;
  font-size: 14px;
  line-height: 30px;
  color: rgb(146, 146, 146);
  flex: 3;
}
.recordRight {
  margin-top: 0px;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(../assets/approving.svg);
}
.recordRight1 {
  margin-top: 0px;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(../assets/toEnterPark.svg);
}
.recordRight2 {
  margin-top: 0px;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(../assets/visiting.svg);
}
.recordRight3 {
  margin-top: 0px;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(../assets/end.svg);
}
.recordRight4 {
  margin-top: 0px;
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(../assets/unapproving.svg);
}
.buttonContainer {
  height: 40px;
  width: 33.3%;
}
</style>



// WEBPACK FOOTER //
// src/components/htistory.vue